/* eslint-disable no-undef */
import NativeProxy from '@cvte/native-proxy';

let nativeProxy: any = null;
if (EASY_ENV_IS_BROWSER && !nativeProxy) {
  nativeProxy = new NativeProxy({
    context: 'enApp',
    log: false,
  });
}

export default nativeProxy || null;
